<form [formGroup]="formGroup" [class.mb-3]="has_mb3" [class.my-3]="has_my3">
  <dk-label [label]="label" [isRequired]="required" [disabled]="disabled || control?.disabled" />
  <p-treeSelect
    class="md:w-20rem w-full"
    containerStyleClass="w-full"
    [formControlName]="controlName"
    (onNodeSelect)="onNodeSelect.emit($event)"
    (onNodeUnselect)="onNodeUnselect.emit($event)"
    (onNodeExpand)="onNodeExpand.emit($event)"
    (onNodeCollapse)="onNodeCollapseFn($event.node)"
    (onShow)="onShow()"
    [options]="nodes"
    [loading]="loading"
    [filter]="filter"
    [disabled]="disabled"
    selectionMode="checkbox"
    [scrollHeight]="screenHight > 900 ? scrollHeight : '150px'"
    [placeholder]="placeholder | translate"
    [appendTo]="appendTo">
    <ng-template let-value pTemplate="value">
      {{ getSelectedNodeLabels(value) ?? this.placeholder | translate }}
    </ng-template>
    <ng-template let-node pTemplate="treenode">
      {{ node.translatePrefix }}
    </ng-template>
  </p-treeSelect>

  <dk-field-validation-error-message [control]="control" />
</form>
